import DashboardIcon from "@mui/icons-material/Dashboard";
import InfoIcon from "@mui/icons-material/Info";
import GavelIcon from "@mui/icons-material/Gavel";
import TimelineIcon from "@mui/icons-material/Timeline";
import DescriptionIcon from "@mui/icons-material/Description";
import PaymentsIcon from "@mui/icons-material/Payments";

export const PROJECT_TABS = [
  { label: "Dashboard", icon: <DashboardIcon /> },
  { label: "Dados Básicos", icon: <InfoIcon /> },
  { label: "Procuração", icon: <GavelIcon /> },
  { label: "Acompanhamento", icon: <TimelineIcon /> },
  { label: "Documentos", icon: <DescriptionIcon /> },
  { label: "Financeiro", icon: <PaymentsIcon /> },
];

export const TAB_KEYS = {
  DASHBOARD: 0,
  BASIC_DATA: 1,
  ATTORNEY: 2,
  TRACKING: 3,
  DOCUMENTS: 4,
  FINANCIAL: 5,
};
